import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import withTranslations from '../../hocs/withTranslations';
import { ITranslations } from '../../interfaces/ITranslationFields';
import CartItemEntity, { SKU_TYPE } from '../../domain/entities/Cart/CartItem';
import ErrorMessages from '../ErrorMessages';
import TranslationUtils from '../../utils/TranslationUtils';
import { IGetPriceOptions } from '../../controllers/OrderSummaryViewController/OrderSummaryViewController';
import {
  CartItemTitle,
  CartItemSize,
  CartItemShade,
  CartItemQuantity,
  CartItemPrices,
  CartItemPreorderMessage,
  CartItemMonogramPrice,
  CartItemImage,
  CartItemReward,
} from './common';
import {
  CartItemDetails,
  CartItemWrapper,
  CartItemError,
  ItemProperty,
  CartItemImageContainer,
} from './common/CommonStyles';

export const AutoReplenishment = styled(ItemProperty)`
`;

interface ICartItemProps {
  baseUrl: string;
  item: CartItemEntity;
  isBopisOrCourier: boolean;
  getPrice(price: number, options?: IGetPriceOptions): string;
  itemNotAvailableForPickUp?: boolean;
  showFreeLabelAsPrice?: boolean;
  translations?: ITranslations;
  splitsEnabled?: boolean;
}

@observer
class CartItem extends React.Component<ICartItemProps> {
  render(): JSX.Element {
    const {
      item,
      item: {
        hexValue,
        productRgnName,
        productSize,
        shadename,
        quantity,
        isRewardItem,
        rewardPoints,
      },
      baseUrl,
      getPrice,
      itemNotAvailableForPickUp,
      showFreeLabelAsPrice,
      isBopisOrCourier,
      translations: {
        complimentaryGift,
        quantity: quantityLabel,
        replenishmentService,
        engraving,
        itemIsTempOutOfStock,
        itemNotAvailableForPickUpError,
        preOrderItem,
        preOrderNoCharge,
        size,
        restrictedApoProduct,
        free,
        donation,
      },
    } = this.props;

    let preOrderMessage = '';
    if (item.isPreOrder && preOrderItem) {
      preOrderMessage = `${preOrderItem} ${item.preOrderMessage}`;
    }

    let subheading: string | string[];
    if (item.skuType === SKU_TYPE.Donation) {
      subheading = donation;
    } else {
      subheading = item.isKitItem && item.kitNames
        ? item.kitNames : item.productRgnSubheading;
    }

    return (
      <div>
        <CartItemWrapper className="acac-cart-item-content">
          <CartItemImageContainer>
            <CartItemImage baseUrl={baseUrl} item={item} />
          </CartItemImageContainer>
          <CartItemDetails>
            <CartItemTitle title={productRgnName} subheading={subheading} />
            {productSize && <CartItemSize productSize={productSize} sizeLabel={size} />}
            {shadename && <CartItemShade shadeName={shadename} hexValue={hexValue} />}
            {!isRewardItem && quantity && <CartItemQuantity quantity={quantity} quantityLabel={quantityLabel} />}
            {!!isRewardItem && <CartItemReward rewardPoints={rewardPoints} />}
            {!isRewardItem && (
              <CartItemPrices
                freeLabel={free}
                showFreeLabelAsPrice={showFreeLabelAsPrice}
                getPrice={getPrice}
                item={item}
                complimentaryGift={complimentaryGift}
              />
            )}
            {item.isPreOrder && (
              <CartItemPreorderMessage
                preOrderMessage={preOrderMessage}
                preOrderNoChargeLabel={preOrderNoCharge}
              />
            )}
            {item.isAutoReplenish && (
            <AutoReplenishment className="acac-cart-item-auto-replenish">
              {TranslationUtils.replace(
                replenishmentService, '::frequency::', item.replenishmentFrequency,
              )}
            </AutoReplenishment>
            )}
            {item.isMonogrammedItem && (
              <CartItemMonogramPrice
                getPrice={getPrice}
                item={item}
                freeLabel ={free}
                showFreeLabelAsPrice={showFreeLabelAsPrice}
                engravingLabel={engraving}
              />
            )}
            {item.isOutOfStock && !isBopisOrCourier && (
            <CartItemError>
              <ErrorMessages messages={[itemIsTempOutOfStock]} />
            </CartItemError>
            )}
            {itemNotAvailableForPickUp && (
            <CartItemError>
              <ErrorMessages messages={[itemNotAvailableForPickUpError]} />
            </CartItemError>
            )}
            {item.hasHazmatError && (
            <CartItemError>
              <ErrorMessages messages={[restrictedApoProduct]} />
            </CartItemError>
            )}
          </CartItemDetails>
        </CartItemWrapper>
      </div>
    );
  }
}

export default withTranslations(CartItem);
